var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDivergencyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33326 12.6665V15.3332H20.6666V12.6665H7.33326ZM13.9999 0.666504C6.63993 0.666504 0.666595 6.63984 0.666595 13.9998C0.666595 21.3598 6.63993 27.3332 13.9999 27.3332C21.3599 27.3332 27.3333 21.3598 27.3333 13.9998C27.3333 6.63984 21.3599 0.666504 13.9999 0.666504ZM13.9999 24.6665C8.11993 24.6665 3.33326 19.8798 3.33326 13.9998C3.33326 8.11984 8.11993 3.33317 13.9999 3.33317C19.8799 3.33317 24.6666 8.11984 24.6666 13.9998C24.6666 19.8798 19.8799 24.6665 13.9999 24.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDivergencyWhite);
export default __webpack_public_path__ + "static/media/IconDivergencyWhite.95d8ebb50472f0a008c0889b4e9e4d7e.svg";
export { ForwardRef as ReactComponent };